<template>
  <div class="tips" @click.stop>
    <div class="title">挑战开始提醒</div>
    <div class="text"
      >点击<span class="pink">去打卡</span
      >即开始挑战，取消则暂不开始。<br /><span class="pink"
        >(每人仅限参与一次)</span
      ></div
    >
    <div class="btn-list">
      <div class="btn-item" @click="bindCancel">取消</div>
      <div class="btn-item btn-item-active" @click="bindClick">去打卡</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: null
    }
  },
  data() {
    return {}
  },
  computed: {
    todayPrizeList() {
      let index = this.data.continuous_day
      return (
        (this.data.sign_task[index] && this.data.sign_task[index].goods_list) ||
        []
      )
    }
  },
  methods: {
    bindClick() {
      this.$emit('confirm')
    },
    bindCancel() {
      this.$emit('cancel')
    }
  }
}
</script>
<style lang="scss" scoped>
.tips {
  text-align: center;
  width: 258px;
  padding: 35px 21px 35px;
  background: #fff;
  border-radius: 10px;

  .image {
    margin: 0 auto;
    margin-top: -50px;
    width: 136px;
    height: 105px;
    object-fit: contain;
    margin-bottom: 18px;
  }

  .title {
    font-weight: bold;
    font-size: 20px;
    color: rgba(0, 0, 0, 0.8);
    line-height: 27px;
    margin-bottom: 13px;
  }

  .text {
    font-weight: bold;
    font-size: 13px;
    color: rgba(0, 0, 0, 0.6);
    line-height: 18px;
    margin-bottom: 21px;

    .pink {
      color: #fc037a;
    }
  }

  .btn-list {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .btn-item {
      width: 120px;
      text-align: center;
      height: 44px;
      box-sizing: border-box;
      border: 1px solid #fc037a;
      background-color: #fff;
      border-radius: 22px;
      font-weight: bold;
      font-size: 16px;
      color: #fc037a;
      line-height: 44px;
    }

    .btn-item-active {
      background-color: #fc037a;
      color: #ffffff;
    }
  }
}
</style>
